// extracted by mini-css-extract-plugin
export default {"button":"Button_button__iEiBG","dark":"Button_dark__U+P1G","disabled":"Button_disabled__gCPRN","image":"Button_image__ux2Yx"};